import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { getTreatment } from "../lib/appointments";

export default function AppointmentSlugPage() {
  const { slug } = useParams();
  const t = getTreatment(slug || "wellness");

  useEffect(() => {
    if (document.querySelector('script[src="https://link.msgsndr.com/js/form_embed.js"]')) return;
    const s = document.createElement("script");
    s.src = "https://link.msgsndr.com/js/form_embed.js"; s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <div style={{minHeight:"100vh", background:"var(--black)"}}>
      <header style={{padding:"22px 5%", borderBottom:"1px solid rgba(193,127,58,.12)", maxWidth:1240, margin:"0 auto"}}>
        <Link to="/" data-testid="appt-logo" style={{
          fontFamily:"var(--font-display)", color:"var(--gold)", fontSize:"1.3rem",
          textDecoration:"none", letterSpacing:".04em"
        }}>Antiaging by BB</Link>
      </header>
      <div className="aa-shell-wide" style={{paddingTop:36}}>
        <div className="aa-eyebrow">In-clinic appointments</div>
        <h1 className="aa-h1" data-testid="appt-title">Book your {t.name.toLowerCase()} visit</h1>
        <p className="aa-sub">Miami, FL · By appointment · Mon, Tue, Thu &amp; Fri 9AM–5PM</p>

        <div style={{background:"#fff", borderRadius:14, overflow:"hidden", padding:8}} data-testid="booking-frame-wrap">
          <iframe
            key={t.calendarId}
            src={`https://api.leadconnectorhq.com/widget/booking/${t.calendarId}`}
            title={`Book ${t.name}`}
            style={{ width:"100%", minHeight: 760, border:"none", display:"block", background:"#fff" }}
            scrolling="no"
            data-testid="booking-iframe"
          />
        </div>
        <p className="aa-caption" style={{marginTop:18}}>
          Need help? Email <a href="mailto:care@antiagingbybb.com">care@antiagingbybb.com</a> · +1 (305) 528 9525
        </p>
      </div>
    </div>
  );
}
